<template>
  <!-- content START here -->
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <!-- main-colum START here -->
      <div id="main-colum">
        <h3>Manage Categories</h3>
        <router-link
          :to="{ path: '/admin/categories/0' }"
          class="big-btn orange"
        >
          Add New Category
        </router-link>
        <br />
        <div v-for="item in categories" :key="item.id" class="post full-width">
          <b>{{ item.category }}</b>
          <br />
          <router-link
            class="sml-btn blue"
            :to="{ path: '/admin/categories/' + item.id }"
          >
            Edit
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CategoryRepository from "../../data/category.repository.js";
export default {
  data() {
    return {
      categories: [],
    };
  },
  created() {
    CategoryRepository.get().then((data) => {
      this.categories = data;
    });
  },
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// ManageCategories.vue?1a5b66ff